import React from "react";

// import { RefreshCw } from "lucide-react";
// import { Button } from "../button";

const FilterContainer = ({ children, onReset }) => {
  return (
    <>
      <div className="lh-1">
        <label className="form-label visually-hidden">
          Reset Filters
        </label>
        <button
          variant="outline"
          size="sm"
          onClick={onReset}
          className="filter-box"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
            <path d="M3 3v5h5"></path>
            <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"></path>
            <path d="M16 16h5v5"></path>
          </svg>{" "}
          Reset
        </button>
      </div>
    </>
  );
};
export default FilterContainer;
